import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './styles/mdi-optimus-theme.css'
import App from './App.tsx'
import { AppWrapper } from './components/common/PageMeta.tsx'
import { ThemeProvider } from './context/theme'
import {
  instalarRecargaDePreload,
  limparTravasDeChunk,
} from './lib/lazyWithReload.ts'
import {
  instalarAtualizacaoDoServiceWorker,
  limparTravaDeRecarga,
} from './lib/swAtualiza.ts'
import { initSentry } from './lib/sentry.ts'

// Initialize Sentry before rendering the app
initSentry()

// Deploy com a aba aberta: o bundle antigo pede chunks que não existem mais e o
// host devolve `index.html` no lugar (200 text/html), quebrando JS e CSS. As duas
// linhas abaixo recuperam disso — ver `lib/lazyWithReload.ts`.
instalarRecargaDePreload()
limparTravasDeChunk()
// Sem isto, a primeira visita depois de um deploy roda o app ANTIGO em silêncio.
instalarAtualizacaoDoServiceWorker()
limparTravaDeRecarga()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <AppWrapper>
        <App />
      </AppWrapper>
    </ThemeProvider>
  </StrictMode>
)
